import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import React, { useState } from "react";
import {
  AuthCheck,
  SuspenseWithPerf,
  useAuth,
  useFirestore,
  useFirestoreDocData,
  useFirestoreDocDataOnce,
} from "reactfire";
import { useHistory } from "react-router-dom";
import type { TicketReservation } from "../../common/types";
import ticketReservationSelectors from "../../selectors/ticketReservationSelectors";
import CheckIcon from "@material-ui/icons/Check";
import Typography from "@material-ui/core/Typography";
import TimelapseIcon from "@material-ui/icons/Timelapse";
import Grid from "@material-ui/core/Grid";
import Badge from "@material-ui/core/Badge";
import ScheduleGameCardFooterStreamButton from "./ScheduleGameCardFooterStreamButton";

function ScheduleGameCardFooter(props) {
  const { ticketReservationStatus, type } = props;

  return <ScheduleGameCardFooterStream />;

  // noinspection UnreachableCodeJS
  return (
    <SuspenseWithPerf traceId={"ScheduleGameCardFooter"} fallback={undefined}>
      <AuthCheck
        fallback={
          ticketReservationStatus !== "CLOSED" && type !== "RESULT" ? (
            <CardActionsWrapper>
              <ReservationAd {...props} />
            </CardActionsWrapper>
          ) : null
        }
      >
        <TicketOrReservationAd {...props} />
      </AuthCheck>
    </SuspenseWithPerf>
  );
}

function CardActionsWrapper({ children }) {
  return (
    <CardActions style={{ paddingTop: 0, justifyContent: "center" }}>
      {children}
    </CardActions>
  );
}

function AdminBar({ children, userData, game, location, type }) {
  const history = useHistory();
  const [showUserView, setShowUserView] = useState(false);

  if (
    userData == null ||
    (!userData.admin && !userData.host) ||
    game == null ||
    showUserView
  ) {
    if (type === "RESULT") {
      return null;
    }
    return children;
  }

  return (
    <CardActionsWrapper>
      <Grid container justify="space-between" alignItems="center">
        <Grid item xs={4}>
          {(userData.host || userData.admin) && (
            <Button
              onClick={() => history.push(`admin/game/${game.id}`)}
              variant="text"
              color="primary"
              size="small"
            >
              Verwalten
            </Button>
          )}
        </Grid>
        <Grid item xs={4} style={{ textAlign: "center" }}>
          <Badge
            color="secondary"
            badgeContent={`${game.ticketReservationCount || 0}\u00a0/\u00a0${
              game.visitorSlots || location.visitorSlots
            }\u00a0Res.`}
          />
        </Grid>
        <Grid item xs={4} style={{ textAlign: "right" }}>
          <Button
            onClick={() => setShowUserView(true)}
            variant="text"
            color="primary"
            size="small"
          >
            User View
          </Button>
        </Grid>
      </Grid>
    </CardActionsWrapper>
  );
}

function TicketOrReservationAd(props) {
  const { game, location, type } = props;
  const auth = useAuth();
  const firestore = useFirestore();
  const user = auth.currentUser;

  const userDataRef = firestore.collection("users").doc(user.uid);
  const userData = useFirestoreDocData(userDataRef);

  const hasTickets =
    userData.gameIdsWithTicketReservations != null &&
    userData.gameIdsWithTicketReservations.includes(game.id);

  if (!hasTickets) {
    return (
      <AdminBar userData={userData} game={game} location={location} type={type}>
        <ReservationAd {...props} />
      </AdminBar>
    );
  }

  return (
    <AdminBar userData={userData} game={game} location={location}>
      <Ticket gameId={game.id} userId={user.uid} firestore={firestore} />
    </AdminBar>
  );
}

function Ticket({ gameId, userId, firestore }) {
  const history = useHistory();

  // user has tickets, so lets get this bread
  const ticketReservationRef = firestore
    .collection("games")
    .doc(gameId)
    .collection("ticketReservations")
    .doc(userId);
  const ticketReservation: TicketReservation = useFirestoreDocDataOnce(
    ticketReservationRef
  );

  return (
    <CardActionsWrapper>
      <Button
        size="small"
        color="primary"
        variant="outlined"
        startIcon={<CheckIcon />}
        onClick={() => history.push(`/ticket/${gameId}`)}
      >
        {ticketReservationSelectors.getTicketWording(ticketReservation)}{" "}
        reserviert
      </Button>
    </CardActionsWrapper>
  );
}

function ReservationAd({
  game,
  location,
  showGameDetails,
  ticketReservationStatus,
}) {
  const availableSlots =
    (game.visitorSlots || location.visitorSlots) - game.ticketReservationCount;

  if (
    availableSlots <= 0 ||
    ticketReservationStatus === "CLOSED" ||
    game.ticketReservationsClosedManually
  ) {
    return (
      <CardActionsWrapper>
        <Button size="small" variant="outlined" disabled>
          Tickets Ausverkauft
        </Button>
      </CardActionsWrapper>
    );
  }

  if (availableSlots <= 20) {
    return (
      <CardActionsWrapper>
        <Grid
          container
          alignItems="center"
          justify="center"
          onClick={showGameDetails}
        >
          <Grid item style={{ lineHeight: 0 }}>
            <TimelapseIcon color="secondary" fontSize="small" />
          </Grid>
          <Grid item>
            <Typography color="secondary" align="center" variant="caption">
              &nbsp;
              {`Nur ${availableSlots} Ticket${
                availableSlots !== 1 ? "s" : ""
              } übrig`.toUpperCase()}
            </Typography>
          </Grid>
        </Grid>
      </CardActionsWrapper>
    );
  }

  return (
    <CardActionsWrapper>
      <Typography
        color="primary"
        align="center"
        variant="caption"
        onClick={showGameDetails}
      >
        {"Tickets verfügbar".toUpperCase()}
      </Typography>
    </CardActionsWrapper>
  );
}

function ScheduleGameCardFooterStream() {
  return (
    <CardActionsWrapper>
      <ScheduleGameCardFooterStreamButton />
    </CardActionsWrapper>
  );
}

export default ScheduleGameCardFooter;
